import axios from 'axios'
import router from './../../../router'
import {Errors, Form} from './../../../components/validations/forms.js'
const namespaced = true;

const state = {
  branches: null,
};

const getters = {
  getBranches (state) {
    return state.branches
  },

};

const mutations = {
  setBranches (state, payload) {
    state.branches = payload
  },
};

const actions = {
  fetchBranches ({commit, dispatch}) {
    return new Promise((resolve, reject) => {
      axios.get('/api/company/branch')
          .then(res => {
            commit('setBranches', res.data.data)
            console.log('fetchBranches - fetchBranches Fetched.');
            resolve(res.data.data);})
          .catch(error => {reject(error.response);})
    })
  },

  fetchSingleBranch ({commit, dispatch}, payload) {
    return new Promise((resolve, reject) => {
      let params = new URLSearchParams();
      axios.defaults.baseURL = hostnames[Math.floor(Math.random()*hostnames.length)]
      axios.get('/api/company/branch/'+payload, {
        params: {
        }
      })
          .then(res => {
            console.log('fetchSingleBranch - fetchSingleBranch Fetched.');
            resolve(res.data.data);
          })
          .catch(error => {
            const issues = new Errors();
            issues.record(error.response);
            reject(issues);
          })
    })
  },

  updateBranch ({commit, dispatch}, payload) {
    return new Promise((resolve, reject) => {
      axios.defaults.baseURL = hostnames[Math.floor(Math.random()*hostnames.length)]
      axios.put('/api/company/branch/'+payload.id, {
          id: payload.id,
          name: payload.name,
      })
          .then(res => {
            console.log('updateBranch - updateBranch Updated.');
            resolve(res.data);
          })
          .catch(error => {
            reject(error.response);
          })
    })
  },

  deleteBranch ({commit, dispatch}, payload) {
    return new Promise((resolve, reject) => {
      axios.defaults.baseURL = hostnames[Math.floor(Math.random()*hostnames.length)]
      axios.delete('/api/company/branch/'+payload)
          .then(res => {
            console.log('deleteBranch - deleteBranch Updated.');
            resolve(res.data);
          })
          .catch(error => {
            reject(error.response);
          })
    })
  },

  storeBranch ({commit, dispatch}, payload) {
    return new Promise((resolve, reject) => {
      axios.defaults.baseURL = hostnames[Math.floor(Math.random()*hostnames.length)]
      axios.post('/api/company/branch', {
        name: payload.name,
      })
          .then(res => {
            console.log('storeBranch - storeBranch Updated.');
            resolve(res.data);
          })
          .catch(error => {
            reject(error.response);
          })
    })
  },


};

export default {
  namespaced,
  state,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/store/modules/company/branches.js